module.exports = __webpack_public_path__ + "static/media/Layout19.156d413e.png";